export default __webpack_public_path__ + "static/media/k.9aceb826.mp4";